import React from "react";
import { useTranslation } from "react-i18next";
import LifestyleUseCases from "../LifestyleUseCases";
import { useTrackerLifestyleData } from "./trackerData";

const LifestyleUseCasesTracker: React.FC = () => {
    const { t } = useTranslation("trackerLifestyle");
    const trackerLifestyleData = useTrackerLifestyleData();

    return (
        <LifestyleUseCases
            data={trackerLifestyleData}
            sectionTitle={{
                regularText: t("sectionTitle.regularText"),
                highlightedText: t("sectionTitle.highlightedText"),
                descriptionHighlight: t("sectionTitle.descriptionHighlight"),
                descriptionText: t("sectionTitle.descriptionText"),
            }}
            className="tracker-lifestyle-section"
        />
    );
};

export default LifestyleUseCasesTracker;
